module.exports = __webpack_public_path__ + "media/blip-1.b006268b.mp3";